import { DirectoryHealthCareProvider } from "@/ContactDirectory/Models/DirectoryHealthCareProvider";
import { DirectoryOtherEstablishment } from "@/ContactDirectory/Models/DirectoryOtherEstablishment";
import { DirectoryPharmacy } from "@/ContactDirectory/Models/DirectoryPharmacy";
import { DirectorySelectableEntity } from "@/ContactDirectory/Models/DirectorySelectableEntity";
import { IDirectoryEntity } from "@/ContactDirectory/Models/IDirectoryEntity";
import { DirectoryEntityAddDto, DirectoryEntityModifyDto } from "../ClientParameters/DirectoryEntityDto";
import { DirectoryHealthCareProviderMapper } from "./DirectoryHealthCareProviderMapper";
import { DirectoryOtherEstablishmentMapper } from "./DirectoryOtherEstablishmentMapper";
import { DirectoryPharmacyMapper } from "./DirectoryPharmacyMapper";

export class DirectoryEntityMapper {
    public static toModifyDto(entity: IDirectoryEntity): DirectoryEntityModifyDto {
        if (entity instanceof DirectoryHealthCareProvider) {
            return DirectoryHealthCareProviderMapper.toModifyDto(entity);
        }
        else if (entity instanceof DirectoryOtherEstablishment) {
            return DirectoryOtherEstablishmentMapper.toModifyDto(entity);
        }
        else if (entity instanceof DirectoryPharmacy) {
            return DirectoryPharmacyMapper.toModifyDto(entity);
        }
        else {
            throw new Error("Unknown directory entity type.");
        }
    }

    public static toAddDto(entity: IDirectoryEntity): DirectoryEntityAddDto {
        if (entity instanceof DirectoryHealthCareProvider) {
            return DirectoryHealthCareProviderMapper.toAddDto(entity);
        }
        else if (entity instanceof DirectoryOtherEstablishment) {
            return DirectoryOtherEstablishmentMapper.toAddDto(entity);
        }
        else if (entity instanceof DirectoryPharmacy) {
            return DirectoryPharmacyMapper.toAddDto(entity);
        }
        else {
            throw new Error("Unknown directory entity type.");
        }
    }

    public static toDirectorySelectableEntity(entity: IDirectoryEntity): DirectorySelectableEntity<IDirectoryEntity> {
        if (!entity)
            return;

        if (entity instanceof DirectoryHealthCareProvider) {
            return DirectoryHealthCareProviderMapper.toDirectorySelectableEntity(entity);
        }
        else if (entity instanceof DirectoryOtherEstablishment) {
            return DirectoryOtherEstablishmentMapper.toDirectorySelectableEntity(entity);
        }
        else if (entity instanceof DirectoryPharmacy) {
            return DirectoryPharmacyMapper.toDirectorySelectableEntity(entity);
        }
        else {
            throw new Error("Unknown directory entity type.");
        }
    }
}
